import { useDialogs } from '@shared/hooks/dialogs'

import Fab from '@mui/material/Fab'
import AddIcon from '@mui/icons-material/Add'

export default function Add() {
    const { show } = useDialogs()

    return (
        <Fab
            variant='extended'
            color='primary'
            sx={{
                position: 'fixed',
                bottom: 15,
                insetInlineEnd: 15,
                fontSize: 15,
                gap: 1
            }}
            onClick={() => show('estimation', null)}
        >
            إضافة مقايسة
            <AddIcon />
        </Fab>
    )
}